import type { RootState } from '~/store/types';

import { Notification, NotificationActionType, NotificationAction } from './types';

export default (state: Notification[] = [], action: NotificationAction): Notification[] => {
	switch (action.type) {
		case NotificationActionType.SHOW_NOTIFICATION:
			return [...state, action.payload];
		case NotificationActionType.HIDE_NOTIFICATION:
			return state.filter(notification => notification.id !== action.payload);
		default:
			return state;
	}
};

export const selectNotifications = (state: RootState) => state.notificationsQueue as Notification[];
